// extracted by mini-css-extract-plugin
module.exports = {"Dialog":"Dialog-2F1gH","actions":"actions-3nCP5"};